import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const paymentsApi = createApi({
  reducerPath: 'paymentsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_CONNECT}/`,
  }),

  tagTypes: ['Payment'],
  refetchOnMountOrArgChange: 1,
  endpoints: (builder) => ({
    getAllPayments: builder.query({
      query: (data) => ({
        url: `payments/${data.id}`,
        method: 'GET',
        headers: {
          'X-User-Token': data.userToken,
          'X-User-Id': data.userId,
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },

      }),
      // keepUnusedDataFor: 1,
      providesTags: ['Payment'],
    }),

 

    createCustomer: builder.mutation({
      query: (data) => {
        console.log('data', data)
        return {
          url: `payments/${data.id}`,
          method: 'POST',
          body: data,
          headers: {
            'X-User-Token': data.userToken,
            'X-User-Id': data.userId,
            'Content-type': 'application/json',
          }
        }
      },
      // keepUnusedDataFor: 1,
      invalidatesTags: ['Payment'],
    }),

    defaultPayments: builder.mutation({
      query: (data) => {
        return {
          url: `payments/${data.id}`,
          method: 'PUT',
          body: data,
          headers: {
            'X-User-Token': data.userToken,
            'X-User-Id': data.userId,
            'Accept': 'application/json',
            'Content-type': 'application/json; charset=UTF-8',
          }
        }
      },
      // keepUnusedDataFor: 1,
      invalidatesTags: ['Payment'],
    }),


    removePayments: builder.mutation({
      query: (data) => {
        return {
          url: `payments/${data.id}`,
          method: 'DELETE',
          body: data,
          headers: {
            'X-User-Token': data.userToken,
            'X-User-Id': data.userId,
            'Accept': 'application/json',
            'Content-type': 'application/json; charset=UTF-8',
          }
        }
      },
      // keepUnusedDataFor: 1,
      invalidatesTags: ['Payment'],
    }),

    cancelMembership: builder.mutation({
      query: (data) => {
        return {
          url: `payments/${data.user_id}`,
          method: 'PUT',
          body: data,
          headers: {
            'X-User-Token': data.userToken,
            'X-User-Id': data.userId,
            'Accept': 'application/json',
            'Content-type': 'application/json; charset=UTF-8',
          }
        }
      },
      // keepUnusedDataFor: 1,
      invalidatesTags: ['Payment'],
    }),

    getAllBilling: builder.query({
      query: (data) => {
        return {
          url: `billing/${data.id}`,
          method: 'GET',
          headers: {
            'X-User-Token': data.userToken,
            'X-User-Id': data.userId,
            'X-User-Role': data.admin,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
        }
      },
      keepUnusedDataFor: 86400000,
      providesTags: ['Payment'],
    }),


    getAllTransaction: builder.query({
      query: (data) => {
        return {
          url: `transactions/${data.id}?page=${data.page}&size=${data.size}`,
          method: 'GET',
          headers: {
            'X-User-Token': data.userToken,
            'X-User-Id': data.userId,
            'X-User-Role': data.admin,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
        }
      },
      keepUnusedDataFor: 86400000,
      providesTags: ['Payment'],
    }),

    updateUser: builder.mutation({
      query: (data) => ({
        url: `billing/${data.id}`,
        method: 'PUT',
        body: data,
        headers: {
          'X-User-Token': data.userToken,
          'X-User-Id': data.userId,
          'X-User-Role': data.admin,
          'Accept': 'application/json',
          'Content-type': 'application/json; charset=UTF-8',
        }
      }),
      keepUnusedDataFor: 86400000,
      invalidatesTags: ['Payment'],
    }),

    chargeNow: builder.mutation({
      query: (data) => ({
        url: `billing/${data.id}`,
        method: 'POST',
        body: data,
        headers: {
          'X-User-Token': data.userToken,
          'X-User-Id': data.userId,
          'X-User-Role': data.admin,
          'Accept': 'application/json',
          'Content-type': 'application/json; charset=UTF-8',
        }
      }),
      keepUnusedDataFor: 86400000,
      invalidatesTags: ['Payment'],
    }),


  }),

})

export const {
  useUpdateUserMutation,
  useGetAllPaymentsQuery,
  useGetAllBillingQuery,
  useGetAllTransactionQuery,
  useCreateCustomerMutation,
  useRemovePaymentsMutation,
  useDefaultPaymentsMutation,
  useCancelMembershipMutation,
  useChargeNowMutation
} = paymentsApi